module.exports = __webpack_public_path__ + "small-house.1b747099ce13216f1030ca6b91e4ddd7.png";